const getParentCategories = ({ data }) => data.parentCategories;
const getCategories = ({ data }) => data.categories;
const getSelectedCategories = ({ data }) => data.selectedCategories;
const getIndicators = ({ data }) => data.indicators;
const getQueryIndicators = ({ router }) => router.indicators || [];
const getRouterView = ({ router }) => router.view;
// Return all distributions excluded from the table for each indicator.
// Note:  this will filter out all zero-length results
// as they are false-positives.
const getQueryDistributions = ({ router }) =>
  getQueryIndicators({ router }).reduce(
    (acc, curr) => (
      router[curr] && router[curr].distribution ? {
        [curr]: router[curr].distribution.filter((x) => x.length),
        ...acc,
      } : acc), {}
    );

export {
  getParentCategories,
  getCategories,
  getSelectedCategories,
  getIndicators,
  getQueryIndicators,
  getQueryDistributions,
  getRouterView,
};



// WEBPACK FOOTER //
// ./app/selectors/basicData.js